module.exports = __webpack_public_path__ + "img/GALLERY-SWIFT-BOOSTER-GREEN-3.55b19c39.jpg";